/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StorageAnalysis } from '../../models/storage-analysis';

export interface ServerStatusControllerFindFolderAndIlsStorageProblems$Params {
}

export function serverStatusControllerFindFolderAndIlsStorageProblems(http: HttpClient, rootUrl: string, params?: ServerStatusControllerFindFolderAndIlsStorageProblems$Params, context?: HttpContext): Observable<StrictHttpResponse<StorageAnalysis>> {
  const rb = new RequestBuilder(rootUrl, serverStatusControllerFindFolderAndIlsStorageProblems.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StorageAnalysis>;
    })
  );
}

serverStatusControllerFindFolderAndIlsStorageProblems.PATH = '/server-status/storageAnalysis';
